import React, { useEffect, useState, useCallback } from 'react';
import {
	Wrapper,
	Label,
	Overlay,
	PopupContainer,
	FormSection,
	CheckboxGroup,
	CheckboxContainer,
	Checkbox,
	CheckboxLabel,
	IndustryWrapper,
	Header,
} from './DownloadDeckPopup.styles';
import { getCompanyMetadataOptions } from 'utils/apiRequests';
import IndustryMultiSelect from 'Benchmarks/ChartOptions/IndustryMultiSelect';
import { ApButtonIcon, ApButtonMain } from '@alixpartners/ui-components';

const DownloadDeckPopup = ({
	handleDownloadDeck,
	handleIndustries,
	onClose,
}) => {
	const [industryOptions, setIndustryOptions] = useState([]);
	const [selectedIndustry, setSelectedIndustry] = useState([]);
	const [investmentType, setInvestmentType] = useState(''); // Can be 'direct', 'indirect', or ''

	useEffect(() => {
		const fetchIndustryOptions = async () => {
			try {
				const { industries } = (await getCompanyMetadataOptions()) || {};
				const options =
					industries?.data?.map(({ key, value }) => ({
						label: value,
						value: key,
					})) || [];
				setIndustryOptions(options);
			} catch (error) {
				console.error('Failed to fetch industry options:', error);
			}
		};

		fetchIndustryOptions();
	}, []);

	useEffect(
		() => {
			handleIndustries(selectedIndustry);
		},
		[selectedIndustry, handleIndustries]
	);

	const handleIndustryChange = useCallback(options => {
		setSelectedIndustry(options);
	}, []);

	const handleClearAllIndustry = useCallback(() => {
		setSelectedIndustry([]);
	}, []);

	return (
		<Overlay>
			<PopupContainer>
				<Header>
					<div style={{ marginTop: '32px' }}>
						<Label as="p">
							<h3>Download Deck</h3>
						</Label>
					</div>
					<div style={{ margin: 'inherit' }}>
						<ApButtonIcon iconName="close" onClick={onClose} />
					</div>
				</Header>

				<FormSection>
					<Label as="p">Spend Type:</Label>

					{/* <CheckboxGroup> */}
					{/* Indirect Checkbox */}
					<CheckboxContainer>
						<Checkbox
							type="radio"
							id="indirect"
							name="investmentType"
							onChange={() => setInvestmentType('indirect')}
							checked={investmentType === 'indirect'}
						/>
						<CheckboxLabel htmlFor="indirect">Indirect</CheckboxLabel>
					</CheckboxContainer>
					{/* Direct Checkbox */}
					<CheckboxContainer>
						<Checkbox
							type="radio"
							id="direct"
							name="investmentType"
							onChange={() => setInvestmentType('direct')}
							checked={investmentType === 'direct'}
						/>
						<CheckboxLabel htmlFor="direct">Direct</CheckboxLabel>
					</CheckboxContainer>
					{/* </CheckboxGroup> */}
				</FormSection>

				{investmentType == 'indirect' && (
					<IndustryWrapper>
						<Label>Select Industry: </Label>

						<IndustryMultiSelect
							name="industry"
							label="Industries"
							options={industryOptions}
							selected={selectedIndustry}
							onChange={handleIndustryChange}
						/>

						{selectedIndustry.length > 0 && (
							<ApButtonIcon
								title="Clear All Industry"
								iconName="close"
								onClick={handleClearAllIndustry}
							/>
						)}
					</IndustryWrapper>
				)}

				<ApButtonMain
					style={{ borderRadius: '5px' }}
					title="Download Deck"
					iconName="outline_save_alt"
					onClick={e => handleDownloadDeck(e, investmentType)}
					disabled={investmentType == ''}
				>
					Download Deck
				</ApButtonMain>
			</PopupContainer>
		</Overlay>
	);
};

export default DownloadDeckPopup;
